import React, {useState, useEffect, useRef} from "react";
// NMU-511: `Form` and `Switch` went with the commented-out fake status toggle
// they were the only users of.
import { Breadcrumb, Divider, Tabs, Card, Button, Input, Row, Col, Dropdown, Menu, Badge, notification } from "antd";
import * as StompJs from '@stomp/stompjs';
import * as Icon from "react-feather";
import { SearchOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import chatService from "../../services/chat-service";
import chatAction from '../../redux/action/chat-action';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateTime, chatConnectStatus, storageKey } from "../../constants/app-constants";
import { APP_CUSTOM_API} from '../../config/app-config';
import notifyUtitls from '../../utils/notify-utils';
import DateTimeUtils from "../../utils/datetime-utils";
import sessionStorageUtils from '../../utils/storage-session-utils';
import { ChatSelector } from "../../redux/selector";

const { TabPane } = Tabs;

const LiveChat = () => {
  const dispatch = useDispatch();
  const [condition, setCondition] = useState({username: null});
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({currentPage: 1,rowPerPage: 10,rowCount: 0 });
  const [selectedChat, setSelectedChat] = useState(null);
  const [currentMessage, setCurrentMessage] = useState('');
  const [connectStatus, setConnectStatus] = useState(chatConnectStatus.NONE);
  const [notiStatus, setNotiStatus] = useState(chatConnectStatus.NONE);
  const [tabChat, setTabChat] = useState('1');
  const wsClient = useRef(null);
  const notiClient = useRef(null);
  const userInfo = useSelector(state => state.authenReducer.userInfo);
  const scrollRef = useRef(null);

  // const countMessage = useSelector(ChatSelector.countReable);

  // console.log('countMessage >>>>>>> ', countMessage);

  useEffect(() => {
    const storageChat = sessionStorageUtils.getItem(storageKey.CHAT_TOKEN);
    const data = JSON.parse(storageChat);
    const client = new StompJs.Client({
      brokerURL: APP_CUSTOM_API.ADMIN_WSK,
      forceBinaryWSFrames: true,
      appendMissingNULLonIncoming: true,
   
      onConnect: () => {
        setConnectStatus(chatConnectStatus.CONNECTED);
      },

      onWebSocketError: (err)=>{
        wsClient.current?.deactivate();
      },

      onDisconnect: () => {
        // console.log('onDisconnect');
        setConnectStatus(chatConnectStatus.DISCONNECTED);
        wsClient.current?.deactivate();
      },

      onStompError: (frame) => {
        wsClient.current?.deactivate();
      },
    });

    wsClient.current = client;

    if(data){
      setSelectedChat(data);
    }

    return () => {
      if(wsClient.current && !data){
        wsClient.current.deactivate();
      }
    }
  }, []);

  useEffect(() => {
    const client = new StompJs.Client({
      brokerURL: APP_CUSTOM_API.ADMIN_WSK,
      forceBinaryWSFrames: true,
      appendMissingNULLonIncoming: true,
   
      onConnect: () => {
        setNotiStatus(chatConnectStatus.CONNECTED);
      },

      onWebSocketError: (err)=>{
        notiClient.current?.deactivate();
      },

      onDisconnect: () => {
        console.log('onDisconnect');
        setNotiStatus(chatConnectStatus.DISCONNECTED);
        notiClient.current?.deactivate();
      },

      onStompError: (frame) => {
        notiClient.current?.deactivate();
      },
    });

    notiClient.current = client;
  }, []);

  useEffect(() => {
    if(chatConnectStatus.NONE === notiStatus && notiClient){
      notiClient.current.activate();
    }

    if (chatConnectStatus.CONNECTED === notiStatus && notiClient) {
        notiClient.current.subscribe("/topic/admin/noti", (message) => {
        const msg = JSON.parse(message.body);
        doCount();
        openNotification();
      },{"user-type":"admin"});
    }
    
  }, [notiStatus, notiClient]);

  useEffect(() => {
    doCount();
  }, []);

  useEffect(() => {
    setSelectedChat(null);
  }, [condition]);

  useEffect(() => {
    if(selectedChat && wsClient && chatConnectStatus.CONNECTED === connectStatus){
      // doSearch(1);
      wsClient.current.activate();
    }
    
    if (chatConnectStatus.CONNECTED === connectStatus && wsClient && selectedChat) {
      wsClient.current.subscribe(selectedChat.topicName, (message) => {
        const msg = JSON.parse(message.body);
        onReceiveMessage(msg);
      },{"user-type":"admin"});
    }
  }, [connectStatus, wsClient, selectedChat]);

  const doCount = async () => {
    let count = await chatService.countReadable();
    await dispatch(chatAction.countReadable(count))
    doSearch(1);
  }

  const openNotification = () => {
    const args = {
      message: 'แจ้งเตือน',
      description:
        'คุณได้รับข้อความใหม่',
      placement:'topRight',
      icon: <InfoCircleOutlined style={{ color: 'blue' }} />
    };
    notification.open(args);
  };

  const doSearch = async (currentPage) => {
    try {
        const newPaginate = {
            ...pagination,
            currentPage: currentPage ? currentPage : pagination.currentPage,
        };

        const newCondition = {
          username : condition.username === '' ? null : condition.username,
          status : true
        }
        let result = await chatService.search(newCondition, newPaginate);

        function compare( a, b ) {
          if ( a.updateTime > b.updateTime ){
            return -1;
          }
          if ( a.updateTime < b.updateTime ){
            return 1;
          }
          return 0;
        }
        result.list.sort(compare);
        setDataList(result.list);
        setPagination(result.pagination ? result.pagination : newPaginate);
    } catch (err) {
        dispatch(notifyUtitls.error(err));
    }
  };

  const onChangeTab = (value) => {
    setTabChat(value);
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  const onKeyUpCondition = (event) => {
    if(event.key === 'Enter'){
      doSearch(1);
    }
  }

  const onKeyUpSentMessage = (event) => {
    if(event.key === 'Enter'){
      onSent();
    }
  }

  const onChangeMessage = ({ target }) => {
    setCurrentMessage(target.value);
  }

  const onSent = () => {

    if (currentMessage === '') {
      return null;
    }

    if (chatConnectStatus.CONNECTED === connectStatus) {
      const msg = {text: currentMessage, from: selectedChat.username, chatId: selectedChat?.id, chatTime: Date.now(), system:"ADMIN"}; // //userInfo.username
      const pushUrl = selectedChat?.topicName.replace('topic', 'push');
      
      wsClient.current.publish({
        destination: pushUrl,
        body: JSON.stringify(msg)
      });

      setCurrentMessage('');
    }
  }

  const onReceiveMessage = (msg) => {
    const newMessages = [...selectedChat.messages, msg];
    const newSelectedChat = {...selectedChat, messages : newMessages};
    setSelectedChat(newSelectedChat);

    let scrollTo = document.getElementById('chat-box-live').scrollHeight
    document.getElementById('chat-box-live').scrollTop = scrollTo

    scrollRef.current?.scrollIntoView({
      behavior: 'smooth',  
      block: "start"
    });
  }

  const onSelectChat = async (item) =>{
    await chatService.read({ id : item.id }).then(() => {
      setSelectedChat(item);
    });
    doCount();
    
    if(item != null){
      wsClient.current.activate();
      sessionStorageUtils.setItem(storageKey.CHAT_TOKEN, JSON.stringify(item));
    }
  }

  /**
   * NMU-511: the socket is only live once a conversation has been selected —
   * `onSelectChat` is what calls `activate()` — so "can I send right now?" is
   * exactly this, and it is what the button and the status line both read.
   */
  const canSend =
    !!selectedChat && chatConnectStatus.CONNECTED === connectStatus;

  /**
   * NMU-511: one composer, rendered in all three tabs.
   *
   * It used to be copy-pasted three times with no disabled state, so `onSent`
   * silently returned whenever the socket was not CONNECTED and the click looked
   * like a dead button — indistinguishable from the transport being broken,
   * which is precisely what made NMU-510 so hard to read. Selecting a
   * conversation renders the thread instantly from the REST payload while
   * `activate()` is still completing, so an admin could reliably hit that window
   * even on a perfectly healthy server.
   *
   * The public widget already behaved this way: `#live-chat-send` in nmu-web's
   * LiveChatWidget is disabled until its STOMP status is `connected`.
   */
  const renderComposer = () => (
    <Row gutter={10} className="my-3">
      <Col span={19}>
        <Input
          value={currentMessage}
          onChange={onChangeMessage}
          placeholder="ข้อความ"
          onKeyUp={onKeyUpSentMessage}
          disabled={!canSend}
        />
      </Col>
      <Col span={5}>
        <Button
          key="submit"
          type="primary"
          className="w-100"
          onClick={onSent}
          disabled={!canSend || !currentMessage.trim()}
        >
          <Icon.Send className="me-2" size={17} />
          บันทึก
        </Button>
      </Col>
    </Row>
  );

  const renderChatMaster = () => {
    let indexClick = null; 

    const clickHandler = async (event, index) => {
      if (event.nativeEvent.which === 3) {
        indexClick = index
      }
      if (event.nativeEvent.which === 1) {
        onSelectChat(dataList[index])
      }
    }

    const closeChat = async () => {
      await chatService.closeChat({ id: dataList[indexClick].id });
      doSearch(1);
    }

    const menuList = (
      <Menu >
        <Menu.Item key="openMenuList">
          <a key="embedClick" onClick={closeChat}>
            <DeleteOutlined /> Delete
          </a>
        </Menu.Item>
      </Menu>
    );

    if (tabChat === '1') {
      return dataList.map(({username, updateTime, messages, id, connectionStatus }, index) => (
        <Dropdown overlay={menuList} trigger={['contextMenu']}>
          <div className="chat-list" key={'chatMaster-'+index}>
            <a onMouseDown={(event) => clickHandler(event, index)} >
              <div className="row p-3 g-0" >
                <div className="col-11">
                  <div className="row g-5">
                    <div className="col-2">
                      <img src="/assets/icon-avatar.png" className="me-3" />
                    </div>
      
                    <div className="col-10">
                      <div className="color-primary-title">
                        {`${username} `}
                        {connectionStatus=="online"?
                          <Badge status="success" /> : <Badge status="default" />}
                      </div>
                      <div className="text-gray-2 text-chat">
                        {/* {messages[0].text} */}
                        {messages[messages?.length-1]?.text}
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-1 text-end">
                  <div className="text-time">
                    {updateTime ? 
                      DateTimeUtils.checkCurrentDate(updateTime)? 
                        DateTimeUtils.parseDateToString( updateTime, formatDateTime.HOURMINUTE ) + 'น.'
                        : DateTimeUtils.parseDateToString( updateTime, formatDateTime.FULLDATETIME ) + 'น.'
                      : null }
                  </div>
                  <div>
                    {countMessageReadable(messages) }
                  </div>
                </div>
              </div>
            </a>
          </div>
        </Dropdown>
      ));
    }
    
    if (tabChat === '2') {
      const render = dataList.filter((chatTopics) => {
        return chatTopics.readable === true;
      })

      return render.map(({username, updateTime, messages, id, connectionStatus }, index) => (
        <div className="chat-list" key={'chatMaster-'+index}>
          <a onClick={() => onSelectChat(dataList[index])}>
          <div className="row p-3 g-0" >
            <div className="col-11">
              <div className="row g-5">
                <div className="col-2">
                  <img src="/assets/icon-avatar.png" className="me-3" />
                </div>
  
                <div className="col-10">
                  <div className="color-primary-title">
                    {username}
                    {connectionStatus=="online"?
                      <Badge status="success" /> : <Badge status="default" />}
                    
                  </div>
                  <div className="text-gray-2 text-chat">
                    {messages[0].text}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1 text-end text-time">
              {updateTime ? 
                      DateTimeUtils.checkCurrentDate(updateTime)? 
                        DateTimeUtils.parseDateToString( updateTime, formatDateTime.HOURMINUTE ) + 'น.'
                        : DateTimeUtils.parseDateToString( updateTime, formatDateTime.FULLDATETIME ) + 'น.'
                      : null }
            </div>
          </div>
          </a>
        </div>
      ));
    }
  
    if (tabChat === '3') {
      const render = dataList.filter((chatTopics) => {
        return chatTopics.readable === false;
      })

      return render.map(({username, updateTime, messages, id }, index) => (
        <div className="chat-list" key={'chatMaster-'+index}>
          <a onClick={() => onSelectChat(dataList[index])}>
          <div className="row p-3 g-0" >
            <div className="col-11">
              <div className="row g-5">
                <div className="col-2">
                  <img src="/assets/icon-avatar.png" className="me-3" />
                </div>
  
                <div className="col-10">
                  <div className="color-primary-title">
                    {username}
                  </div>
                  <div className="text-gray-2 text-chat">
                    {messages[0].text}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1 text-end text-time">
              {updateTime ? 
                      DateTimeUtils.checkCurrentDate(updateTime)? 
                        DateTimeUtils.parseDateToString( updateTime, formatDateTime.HOURMINUTE ) + 'น.'
                        : DateTimeUtils.parseDateToString( updateTime, formatDateTime.FULLDATETIME ) + 'น.'
                      : null }
            </div>
          </div>
          </a>
        </div>
      ));
    }
  }

  const renderChatDetail = () => {
    return (
      <div ref={scrollRef}>
        { selectedChat ? 
          <div id={'chat-box-live'}  className="chat-boxmain">
            <div className="admin-chat">
              <img src="/assets/icon-avatar.png" className="me-3" />
              <div>{selectedChat.username}</div>
            </div>
            {renderMessage(selectedChat.messages, selectedChat.username, selectedChat.id)}
          </div>
          : 'ไม่มีรายการแชทที่เลือก'
        }
      </div>
    )
  }

  const countMessageReadable = (messages) =>{
    let count = 0
    messages.map(({readable} ) => { 
      if(!readable){
        count+=1
      }
    })
    if(count > 0){
      return<Badge count={`N`} />
    }
  }

  /**
   * NMU-465: which side a message belongs to.
   *
   * It is NOT `from === username`: onSent publishes staff replies with
   * `from: selectedChat.username` (the guest's name), so that test matched every
   * message and the whole thread rendered on one side. `system` is the real
   * discriminator — PublicChatBroker switches on it server-side and nmu-web's
   * LiveChatWidget already reads it the same way. The opening
   * "Starting chat with : ..." log is written with from="System" and no system
   * value, which makes it the third case.
   */
  const messageSide = ({ from, system }) => {
    if (from === 'System') {
      return 'system';
    }
    return String(system || '').toUpperCase() === 'ADMIN' ? 'admin' : 'guest';
  };

  const formatChatTime = (chatTime) => {
    if (!chatTime) {
      return null;
    }
    return DateTimeUtils.checkCurrentDate(chatTime)
      ? DateTimeUtils.parseDateToString(chatTime, formatDateTime.HOURMINUTE) + 'น.'
      : DateTimeUtils.parseDateToString(chatTime, formatDateTime.FULLDATETIME) + 'น.';
  };

  const renderMessage = (messages, username, id) =>{
    return messages.map((message, index) => {
      const { text, chatTime } = message;
      const side = messageSide(message);

      if (side === 'system') {
        return (
          <div className="chat-msg-system" key={'chatMessage-' + index} data-side="system">
            <span>{text}</span>
          </div>
        );
      }

      const isAdmin = side === 'admin';

      return (
        <div
          className={isAdmin ? 'chat-msg-row chat-msg-row-admin' : 'chat-msg-row chat-msg-row-guest'}
          key={'chatMessage-' + index}
          data-side={side}
        >
          <div className="chat-msg-col">
            <div className="chat-msg-sender">{isAdmin ? 'เจ้าหน้าที่' : username}</div>
            <div className={isAdmin ? 'chat-msg-bubble chat-msg-bubble-admin' : 'chat-msg-bubble chat-msg-bubble-guest'}>
              {text}
            </div>
            <div className="chat-msg-time">{formatChatTime(chatTime)}</div>
          </div>
        </div>
      );
    });
  }

  return (
    <div>
      <h2 className="color-primary-title">แชท</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการแชท</Breadcrumb.Item>
        <Breadcrumb.Item>แชท</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />

      <Card className="mt-4" bordered={false}>
        {/*
          NMU-511: the real connection state, replacing a commented-out block
          that toggled a label from a local `isOpen` switch and never reflected
          the socket at all. With nothing on screen saying otherwise, "the button
          does nothing" was the only symptom a disconnected socket produced.
        */}
        <div id="chat-connection-status" className="mb-3">
          {!selectedChat ? (
            <span style={{ color: "grey" }}>เลือกห้องแชทเพื่อเริ่มสนทนา</span>
          ) : canSend ? (
            <span style={{ color: "green" }}>
              <Badge status="success" /> เชื่อมต่อแล้ว
            </span>
          ) : (
            <span style={{ color: "grey" }}>
              <Badge status="default" /> กำลังเชื่อมต่อ…
            </span>
          )}
        </div>
        <Row gutter={30}>
          <Col span={8}>
            <Input
              size="small"
              placeholder="Search"
              prefix={
                <SearchOutlined style={{ transform: "translateY(-1px)" }} />
              }
              name="username"
              value={condition.username}
              onChange={onChangeCondition}
              onKeyUp={onKeyUpCondition}
            />
            <div className="border-chat-group mt-3">
              <div className="chat-group ">
                {renderChatMaster()}
              </div>
            </div>
          </Col>
          <Col span={16}>
            <Tabs defaultActiveKey="1" onChange={onChangeTab}>
              <TabPane tab="ข้อความทั้งหมด" key="1" >
                <div className="chat-boxmain">
                  {/* Admin chat */}
                  {renderChatDetail()}
                </div>
                <Divider />
                {renderComposer()}
              </TabPane>
              <TabPane tab="ข้อความอ่านแล้ว" key="2">
                <div className="chat-boxmain">
                  {/* Admin chat */}
                  {renderChatDetail()}
                </div>
                <Divider />
                {renderComposer()}
              </TabPane>
              <TabPane tab="ข้อความไม่ได้อ่าน" key="3">
                <div className="chat-boxmain">
                  {/* Admin chat */}
                  {renderChatDetail()}
                </div>
                <Divider />
                {renderComposer()}
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default LiveChat;
